export const AllPortfoliosConstants = {
    Id: -1,
    Name: "All portfolios",
    StorageValue: "__all-portfolios__",
};
